// Libs
import sum from 'lodash/sum';
import { RootState } from 'redux/store';
// App
import { Order } from './bag.slice.interfaces';
import { computeProductTotal } from './bag.slice.utils';

export const selectBagOrder = (state: Readonly<RootState>): Order => state.bag.order;

export const countProductsInBag = (state: Readonly<RootState>): number =>
  (state.bag.order && sum(state.bag.order.products.flatMap((product) => product.quantity))) || 0;

export const getProductsTotalPriceInBag = () => (state: Readonly<RootState>): number => {
  if (!state.bag || !state.bag.order) return 0;

  return sum(state.bag.order.products.flatMap((product) => computeProductTotal(product)));
};

export const getTotalPriceInBag = () => (state: Readonly<RootState>): number => getProductsTotalPriceInBag()(state);

export const isBagLoading = (state: Readonly<RootState>): boolean => state.bag.isLoading;

export const selectBagCreatedDate = (state: Readonly<RootState>): Date => state.bag.createdDate;
